// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manual-mode-container {
    width: 100% !important;
    height: 99.8vh !important;
    height: calc(1vh * 100);
    height: calc(var(--vh, 1vh) * 100);
    z-index: 0;
}

.border {
    border: 1px solid black;
    border-radius: 10px 0 0 10px;
}

.border-button {
    border: 1px solid black;
    border-radius: 4px 0 0 4px;
}

.app-icon-manual-mode {
    font-size: 15px;
    border-radius: 3px;
    padding: 11px;
    margin: 5px;
    cursor: pointer;
    height: 48px;
    width: 256px;
    color: var(--theme-text-color) !important;
}

.app-icon-manual-mode:hover {
    box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, 0.46);
}

.app-icon-open-manual-mode, .app-icon-open-manual-mode:hover {
    box-shadow: inset 0 0 3px 0.5px rgba(0, 0, 0, 0.46);
}

.app-icon-closeable-handle-manualmode {
    font-size: 15px;
    position: absolute;
    right: 24px;
}

.app-icon-title-manualmode {
    padding-left: 20px;
}

.buttons-row-margin-side-pan {
    margin-top: 5px;
    margin-left: 4px;
}

.settings-box {
    background: rgb(255, 255, 255);
    position: absolute;
    left: 3vh;
    bottom: 0;
    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;
    z-index: 2147483640;
    border-radius: 5px 5px 0 0;
    padding: 16px 24px;
    line-height: 1.5715;
    width: 300px;
    max-width: calc(100vw - 48px);
    margin-bottom: 16px;
    margin-left: auto;
    overflow: hidden;
    border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/manualmode.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,gDAAgD;IAChD,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".manual-mode-container {\n    width: 100% !important;\n    height: 99.8vh !important;\n    height: calc(1vh * 100);\n    height: calc(var(--vh, 1vh) * 100);\n    z-index: 0;\n}\n\n.border {\n    border: 1px solid black;\n    border-radius: 10px 0 0 10px;\n}\n\n.border-button {\n    border: 1px solid black;\n    border-radius: 4px 0 0 4px;\n}\n\n.app-icon-manual-mode {\n    font-size: 15px;\n    border-radius: 3px;\n    padding: 11px;\n    margin: 5px;\n    cursor: pointer;\n    height: 48px;\n    width: 256px;\n    color: var(--theme-text-color) !important;\n}\n\n.app-icon-manual-mode:hover {\n    box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, 0.46);\n}\n\n.app-icon-open-manual-mode, .app-icon-open-manual-mode:hover {\n    box-shadow: inset 0 0 3px 0.5px rgba(0, 0, 0, 0.46);\n}\n\n.app-icon-closeable-handle-manualmode {\n    font-size: 15px;\n    position: absolute;\n    right: 24px;\n}\n\n.app-icon-title-manualmode {\n    padding-left: 20px;\n}\n\n.buttons-row-margin-side-pan {\n    margin-top: 5px;\n    margin-left: 4px;\n}\n\n.settings-box {\n    background: rgb(255, 255, 255);\n    position: absolute;\n    left: 3vh;\n    bottom: 0;\n    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;\n    z-index: 2147483640;\n    border-radius: 5px 5px 0 0;\n    padding: 16px 24px;\n    line-height: 1.5715;\n    width: 300px;\n    max-width: calc(100vw - 48px);\n    margin-bottom: 16px;\n    margin-left: auto;\n    overflow: hidden;\n    border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
